import { formatMonto } from "../../utils";
import { instanceOf } from "prop-types";
import { getFriendlyLocalDateTimeString } from "../../utils/dates";

const PurchaseInline = ({ purchase }) => {
  console.log(purchase)
  return (
    <div>
      {purchase?.purchase_id && (
        <>
          <span className="d-block">
            <span className="text-primary">
              {"[#"}
              {purchase.invoice_id ? purchase.invoice_id : purchase.purchase_id}
              {"]"}
            </span>
            <span className="ms-2">{purchase.title}</span>
          </span>
          <span className="d-block small">
            {getFriendlyLocalDateTimeString(purchase.createdAt)}
          </span>
          {purchase.invoice_id ? <i className="fa fa-undo"></i> : ""}
          {purchase.enabled_by ||
            ((purchase.admin_enabled || purchase.purchase?.admin_enabled) && (
              <i className="fa fa fa-user-shield"></i>
            ))}
          <span className="d-block small">
            ${formatMonto(purchase.amount)} MXN
          </span>
          {String(purchase.seller_name).trim() !== "" && purchase.seller_name !== null && (
            <span className="d-block small text-primary">
              <i className="fa fa-user me-1"></i> {purchase.seller_name}
            </span>
          )}
        </>
      )}
    </div>
  );
};

PurchaseInline.propTypes = {
  purchase: instanceOf(Object),
};

export default PurchaseInline;
